/**
 * Реализация паттерна
 * [Button]{@link https://www.w3.org/WAI/ARIA/apg/patterns/button/}
 */
class AriaButton extends HTMLElement {
    constructor() {
        super();
        this.classList.toggle('_disabled', this.isDisabled);
        this.setAttribute('role', 'button');
        this.setAttribute('tabindex', this.getAttribute('tabindex') ?? '0');
    }

    get isDisabled() {
        return this.hasAttribute('aria-disabled');
    }

    set isDisabled(flag) {
        this.classList.toggle('_disabled', flag);
        this.toggleAttribute('aria-disabled', flag);
    }
}

customElements.define('aria-button', AriaButton);
export default AriaButton;
